// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Creditor } from './creditor';
import { MeetingAttendance } from './meeting-attendance';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ProxyType extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  proxyTypeId!: number;
  createdBy!: string;
  createdDate!: Date;
  description!: string;
  locationId!: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  creditors!: Creditor[];
  meetingAttendances!: MeetingAttendance[];
}

